import { DateTime } from 'luxon';

import { constants } from '@nhl/formatter-utilities';

const getSortedCountryData = (countryData) => {
    countryData.forEach((country) => {
        country.stateProvinces.sort((a, b) => {
            if (a.stateProvinceName < b.stateProvinceName) {
                return -1;
            }
            if (a.stateProvinceName > b.stateProvinceName) {
                return 1;
            }
            return 0;
        });
    });
    return countryData;
};

/**
 * We will format the startDate, regularSeasonEndDate, and endDate here so we won't have to format later on
 * We will add in the different options for how a game was decided
 *
 * Finally we will exclude future seasons, and create a map instead of a []
 */
const getSeasonData = (seasonData) => {
    Object.keys(seasonData).forEach((year) => {
        const season = seasonData[year];

        const convertDate = (date) => DateTime.fromISO(date).toISODate();
        season.startDate = convertDate(season.startDate);
        season.regularSeasonEndDate =
            constants.OVERLAPPING_PLAYOFF_SEASONS_START_DATES[season.id] || convertDate(season.regularSeasonEndDate);
        season.endDate = convertDate(season.endDate);

        const gameResults = ['W', 'L'];
        const gameDecidedIn = ['REG', 'OT'];
        if (season.tiesInUse === 1) {
            gameResults.push('T');
        } else {
            gameDecidedIn.push('SO');
        }
        if (season.pointForOTLossInUse === 1) {
            gameResults.push('O');
        }
        season.gameResults = gameResults;
        season.gameDecidedIn = gameDecidedIn;
    });

    const today = DateTime.local();
    return seasonData
        .filter((season) => today > DateTime.fromISO(season.startDate))
        .reduce((seasonMap, season) => ({ ...seasonMap, [season.id]: season }), {});
};

export default {
    getSortedCountryData,
    getSeasonData,
};
